import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    error: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Error message when subscription info cannot be retrieved */
            error: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useResumePlan.error?c=sc3y5r1470fa", defaultMessage: "Something went wrong retrieving your subscription info" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
